import React from 'react';

import styled from 'styled-components';

const DOT_WRAPPER_SIZE = 20;
const DOT_SIZE = 10;

const CSSDots = styled.div`
    display: flex;
    position: relative;
    overflow: hidden;
`;

const CSSMovingDots = styled.div<{ left: number }>`
    display: flex;
    position: relative;
    overflow: hidden;
    margin-left: 50%;
    transition: left 0.4s;
    left: ${(props) => props.left}px;
    border-radius: 10px;
    background-color: rgba(0, 0, 0, 0.4);
`;

const CSSDotWrapper = styled.button`
    width: ${DOT_WRAPPER_SIZE}px;
    height: ${DOT_WRAPPER_SIZE}px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const CSSDot = styled.div<{ value: number }>`
    background-color: ${(props) => props.theme.color.white};
    width: ${DOT_SIZE}px;
    height: ${DOT_SIZE}px;
    border-radius: ${DOT_SIZE}px;
    transition: all 0.4s;
    transform: scale(${(props) => props.value});
    opacity: ${(props) => props.value};
`;

export function neighborValue(index: number, step: number, range: number, rangeDecreaseValue = 0.25) {
    const diff = Math.abs(index - step);
    if (diff > range) {
        return 0;
    }
    return 1 - diff * rangeDecreaseValue;
}

/**
 *  TODO: STANDALONE COMPONENT
 */
export const SliderDots = ({
    step,
    steps,
    range = 2,
    rangeDecreaseValue = 0.25,
    onClick,
}: {
    step: number;
    steps: number;
    range?: number;
    rangeDecreaseValue?: number;
    onClick: (index: number) => void;
}) => {
    return (
        <CSSDots>
            <CSSMovingDots left={(step * DOT_WRAPPER_SIZE + DOT_WRAPPER_SIZE / 2) * -1}>
                {[...Array(steps).keys()].map((_, index) => {
                    return (
                        <CSSDotWrapper key={index} onClick={() => onClick(index)}>
                            <CSSDot value={neighborValue(index, step, range, rangeDecreaseValue)} />
                        </CSSDotWrapper>
                    );
                })}
            </CSSMovingDots>
        </CSSDots>
    );
};
